import { localesByCulture } from './constants.ts';

export const capitalize = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const countryCodeFromCulture = (culture: string): string => {
  return localesByCulture.get(culture)?.split('-')[1].toUpperCase() ?? 'GR';
};

export const formatPhone = (phone: string): string => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  return `(+${cleaned.slice(0, 2)}) ${cleaned.slice(2, 5)} ${cleaned.slice(5, 8)} ${cleaned.slice(8)}`;
};

// Converts a string to normalized uppercase without diacritics
export function normalize(str: string): string {
  if (!str) return '';

  // First normalize the string to decomposed form (NFKD)
  // Then replace all combining diacritical marks
  // Finally convert to uppercase
  return (
    str
      .normalize('NFKD')
      // Remove combining diacritical marks
      .replace(/[\u0300-\u036f]/g, '')
      // Keep only letters, numbers, and spaces
      .replace(/[^\p{L}\p{N}\s]/gu, '')
      // Convert to uppercase
      .toUpperCase()
      // Remove extra spaces
      .trim()
      .replace(/\s+/g, ' ')
  );
}

export const parseFloatWithCulture = (value: string, culture: string) => {
  const locale = localesByCulture.get(culture);
  if (!locale) throw new Error(`Unsupported culture ${culture}`);

  const numberFormat = new Intl.NumberFormat(locale);
  const parts = numberFormat.formatToParts(12345.67); // Get format info

  // Convert input string according to locale format
  const decimalSeparator = parts.find((p) => p.type === 'decimal')?.value;
  const thousandsSeparator = parts.find((p) => p.type === 'group')?.value;

  let normalizedValue = value;
  if (thousandsSeparator) {
    normalizedValue = normalizedValue.replace(
      new RegExp(`\\${thousandsSeparator}`, 'g'),
      '',
    );
  }
  if (decimalSeparator) {
    normalizedValue = normalizedValue.replace(decimalSeparator, '.');
  }

  return parseFloat(normalizedValue);
};

// Get file size in human-readable format
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

export const formatPrice = (price: number) => {
  return new Intl.NumberFormat().format(price);
};

export const makeUnicodeFlagEmoji = (countryCode: string): string => {
  const code = countryCode.toUpperCase();
  return String.fromCodePoint(
    0x1f1e6 - 0x41 + code.charCodeAt(0),
    0x1f1e6 - 0x41 + code.charCodeAt(1),
  );
};

export const xssSanitize = (str: string): string =>
  str.replace(/[^\p{L}\p{N}\s]/gu, '');
